module.exports = __webpack_public_path__ + "img/icon-date.c43f0ea5.svg";